import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../../includes/custom/css/faq.css';
class AccordionSection extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    this.props.onClick(this.props.label);
  };

  render() {
    const {
      onClick,
      props: { isOpen, label },
    } = this;

    return (
      <div class="accordion-panel">
        <div onClick={onClick} style={{ cursor: 'pointer' }} class={ !isOpen ? "accordion-header-panel accordion-toggle " : "accordion-header-panel accordion-toggle"}>
          <div class={!isOpen? "collapsed": ""}>{label}</div>
        </div>
        {isOpen && (
          <div
          class="accordion-body-panel"
          >
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default AccordionSection;